/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PortalActiveLabSessionDto,
  PortalEndSessionRequest,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiPortalMeLabSessionActive = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalActiveLabSessionDto>(
      {url: `/api/portal/me/lab-session/active`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeLabSessionActiveInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/lab-session/active`
    ] as const;
    }

export const getGetApiPortalMeLabSessionActiveQueryKey = () => {
    return [
    `/api/portal/me/lab-session/active`
    ] as const;
    }


export const getGetApiPortalMeLabSessionActiveInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>>, TError = ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeLabSessionActiveInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>> = ({ signal }) => getApiPortalMeLabSessionActive(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeLabSessionActiveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>>
export type GetApiPortalMeLabSessionActiveInfiniteQueryError = ProblemDetails


export function useGetApiPortalMeLabSessionActiveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>>, TError = ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeLabSessionActiveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeLabSessionActiveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeLabSessionActiveInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeLabSessionActiveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeLabSessionActiveQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeLabSessionActiveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>> = ({ signal }) => getApiPortalMeLabSessionActive(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeLabSessionActiveQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>>
export type GetApiPortalMeLabSessionActiveQueryError = ProblemDetails


export function useGetApiPortalMeLabSessionActive<TData = Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeLabSessionActive<TData = Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeLabSessionActive<TData = Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeLabSessionActive<TData = Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeLabSessionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeLabSessionActiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiPortalMeLabSessionSessionIdEnd = (
    sessionId: string,
    portalEndSessionRequest?: PortalEndSessionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalActiveLabSessionDto>(
      {url: `/api/portal/me/lab-session/${sessionId}/end`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalEndSessionRequest, signal
    },
      options);
    }




export const getPostApiPortalMeLabSessionSessionIdEndMutationOptions = <TError = ProblemDetails | PortalActiveLabSessionDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdEnd>>, TError,{sessionId: string;data?: PortalEndSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdEnd>>, TError,{sessionId: string;data?: PortalEndSessionRequest}, TContext> => {

const mutationKey = ['postApiPortalMeLabSessionSessionIdEnd'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdEnd>>, {sessionId: string;data?: PortalEndSessionRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  postApiPortalMeLabSessionSessionIdEnd(sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeLabSessionSessionIdEndMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdEnd>>>
    export type PostApiPortalMeLabSessionSessionIdEndMutationBody = PortalEndSessionRequest | undefined
    export type PostApiPortalMeLabSessionSessionIdEndMutationError = ProblemDetails | PortalActiveLabSessionDto

    export const usePostApiPortalMeLabSessionSessionIdEnd = <TError = ProblemDetails | PortalActiveLabSessionDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdEnd>>, TError,{sessionId: string;data?: PortalEndSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdEnd>>,
        TError,
        {sessionId: string;data?: PortalEndSessionRequest},
        TContext
      > => {
      return useMutation(getPostApiPortalMeLabSessionSessionIdEndMutationOptions(options), queryClient);
    }
    export const postApiPortalMeLabSessionSessionIdResume = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalActiveLabSessionDto>(
      {url: `/api/portal/me/lab-session/${sessionId}/resume`, method: 'POST', signal
    },
      options);
    }




export const getPostApiPortalMeLabSessionSessionIdResumeMutationOptions = <TError = ProblemDetails | PortalActiveLabSessionDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdResume>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdResume>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['postApiPortalMeLabSessionSessionIdResume'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdResume>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  postApiPortalMeLabSessionSessionIdResume(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeLabSessionSessionIdResumeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdResume>>>

    export type PostApiPortalMeLabSessionSessionIdResumeMutationError = ProblemDetails | PortalActiveLabSessionDto

    export const usePostApiPortalMeLabSessionSessionIdResume = <TError = ProblemDetails | PortalActiveLabSessionDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdResume>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeLabSessionSessionIdResume>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getPostApiPortalMeLabSessionSessionIdResumeMutationOptions(options), queryClient);
    }
